import React, { useEffect, useState, useCallback } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Button,
  Table,
  Label,
  Form,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import { useHistory } from "react-router-dom"
import ReactPaginate from "react-paginate"
import { URLS } from "../../Url"
import axios from "axios"

const ProductsVariants = () => {
  const navigate = useHistory()
  const GetAuth = localStorage.getItem("authUser")
  const TokenJson = JSON.parse(GetAuth)
  const TokenData = TokenJson.token

  const ProductId = sessionStorage.getItem("Productid")

  const [form, setForm] = useState({
    productId: ProductId,
    variantId: "",
    variantOptionId: "",
    price: "",
  })

  const [show, setShow] = useState(false)
  const [showEdit, setShowEdit] = useState(false)
  const [data, setData] = useState([])
  const [variant, setVariant] = useState([])
  const [variantOptions, setVariantOptions] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  // Fetch data functions
  const fetchData = useCallback(async () => {
    setIsLoading(true)
    try {
      const token = TokenData
      const res = await axios.post(
        URLS.GetManageVariation,
        { productId: ProductId },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      setData(res.data.data || [])
    } catch (error) {
      console.error("Error fetching data:", error)
      toast.error("Failed to fetch variants data")
    } finally {
      setIsLoading(false)
    }
  }, [TokenData])

  const fetchVariants = useCallback(async () => {
    try {
      const token = TokenData
      const res = await axios.post(
        URLS.GetVariation,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      setVariant(res.data.variations || [])
    } catch (error) {
      console.error("Error fetching variants:", error)
      toast.error("Failed to fetch variants")
    }
  }, [TokenData])

  const fetchVariantOptions = useCallback(
    async variationId => {
      if (!variationId) return

      try {
        const token = TokenData
        const res = await axios.post(
          URLS.GetVariationByOptions,
          { variationId },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        setVariantOptions(res.data.variationoptions || [])
      } catch (error) {
        console.error("Error fetching variant options:", error)
        toast.error("Failed to fetch variant options")
      }
    },
    [TokenData]
  )

  useEffect(() => {
    fetchData()
    fetchVariants()
  }, [fetchData, fetchVariants])

  const handleSearch = async e => {
    const { value } = e.target
    if (!value) {
      fetchData()
      return
    }

    try {
      const token = TokenData
      const res = await axios.post(
        `${URLS.GetManageVariationSearch}${value}`,
        { productId: ProductId },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      setData(res.data.data || [])
    } catch (error) {
      console.error("Search error:", error)
      if (error.response?.status === 400) {
        toast.error(error.response.data.message)
      } else {
        toast.error("Search failed")
      }
    }
  }

  const handleVariantChange = e => {
    const { name, value } = e.target
    setForm(prev => ({
      ...prev,
      [name]: value,
      variantOptionId: "",
    }))

    if (name === "variantId") {
      fetchVariantOptions(value)
    }
  }

  // Pagination
  const [listPerPage] = useState(10)
  const [pageNumber, setPageNumber] = useState(0)
  const pagesVisited = pageNumber * listPerPage
  const currentItems = data.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(data.length / listPerPage)
  const changePage = ({ selected }) => setPageNumber(selected)

  // Form handling
  const toggleAddForm = () => {
    setShow(!show)
    setShowEdit(false)
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  const handleChange = e => {
    const { name, value } = e.target
    setForm(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async e => {
    e.preventDefault()
    const token = TokenData
    setIsLoading(true)

    try {
      const res = await axios.post(URLS.AddManageVariation, form, {
        headers: { Authorization: `Bearer ${token}` },
      })
      if (res.status === 200) {
        toast.success(res.data.message)
        setShow(false)
        fetchData()
        setForm({
          productId: ProductId,
          variantId: "",
          variantOptionId: "",
          price: "",
        })
      }
    } catch (error) {
      console.error("Submission error:", error)
      if (error.response?.status === 400) {
        toast.error(error.response.data.message)
      } else {
        toast.error("Failed to submit variant")
      }
    } finally {
      setIsLoading(false)
    }
  }

  const [editForm, setEditForm] = useState(null)

  const handleEdit = item => {
    setEditForm(item)
    setShow(false)
    setShowEdit(true)
    fetchVariantOptions(item.variantId)
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  const handleEditChange = e => {
    const { name, value } = e.target
    setEditForm(prev => ({ ...prev, [name]: value }))
  }

  const handleEditSubmit = async e => {
    e.preventDefault()
    if (!editForm) return

    const token = TokenData
    setIsLoading(true)

    try {
      const res = await axios.put(
        `${URLS.EditManageVariation}${editForm._id}`,
        editForm,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      if (res.status === 200) {
        toast.success(res.data.message)
        setShowEdit(false)
        fetchData()
      }
    } catch (error) {
      console.error("Update error:", error)
      if (error.response?.status === 400) {
        toast.error(error.response.data.message)
      } else {
        toast.error("Failed to update variant")
      }
    } finally {
      setIsLoading(false)
    }
  }

  const handleDelete = async item => {
    const confirmBox = window.confirm("Do you really want to delete this item?")
    if (!confirmBox) return

    const token = TokenData
    setIsLoading(true)

    try {
      const res = await axios.delete(
        `${URLS.DeleteManageVariation}${item._id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      if (res.status === 200) {
        toast.success(res.data.message)
        fetchData()
      }
    } catch (error) {
      console.error("Deletion error:", error)
      if (error.response?.status === 400) {
        toast.error(error.response.data.message)
      } else {
        toast.error("Failed to delete variant")
      }
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Bizzmate Supplier"
            breadcrumbItem="Manage Product Variant"
          />

          {show && (
            <Row>
              <Col md={12}>
                <Card className="p-4">
                  <Form onSubmit={handleSubmit}>
                    <h5 className="mb-3">Create Manage Product Variant</h5>
                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label>
                            Variant <span className="text-danger">*</span>
                          </Label>
                          <select
                            value={form.variantId}
                            name="variantId"
                            required
                            onChange={handleVariantChange}
                            className="form-select"
                            disabled={isLoading}
                          >
                            <option value="">Select Variant</option>
                            {variant.map(item => (
                              <option key={item._id} value={item._id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label>
                            Variant Option
                            <span className="text-danger">*</span>
                          </Label>
                          <select
                            value={form.variantOptionId}
                            name="variantOptionId"
                            required
                            onChange={handleChange}
                            className="form-select"
                            disabled={!form.variantId || isLoading}
                          >
                            <option value="">Select Variant Options</option>
                            {variantOptions.map(item => (
                              <option key={item._id} value={item._id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </Col>
                      <Col md={4}>
                        <Label>
                          Price <span className="text-danger">*</span>
                        </Label>
                        <Input
                          onChange={handleChange}
                          name="price"
                          value={form.price}
                          required
                          type="number"
                          min="0"
                          step="0.01"
                          placeholder="Enter price"
                          disabled={isLoading}
                        />
                      </Col>
                    </Row>
                    <div className="text-end mt-4">
                      <Button
                        type="button"
                        size="sm"
                        onClick={() => setShow(false)}
                        color="danger m-1"
                        disabled={isLoading}
                      >
                        Cancel <i className="bx bx-x-circle"></i>
                      </Button>
                      <Button
                        type="submit"
                        size="sm"
                        color="primary text-white m-1"
                        disabled={isLoading}
                      >
                        {isLoading ? "Submitting..." : "Submit"}{" "}
                        <i className="bx bx-check-circle"></i>
                      </Button>
                    </div>
                  </Form>
                </Card>
              </Col>
            </Row>
          )}

          {showEdit && editForm && (
            <Row>
              <Col md={12}>
                <Card className="p-4">
                  <Form onSubmit={handleEditSubmit}>
                    <h5 className="mb-3">Edit Manage Product Variant</h5>
                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label>
                            Variant<span className="text-danger">*</span>
                          </Label>
                          <select
                            value={editForm.variantId}
                            name="variantId"
                            required
                            onChange={handleEditChange}
                            className="form-select"
                            disabled={isLoading}
                          >
                            <option value="">Select Variant</option>
                            {variant.map(item => (
                              <option key={item._id} value={item._id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label>
                            Variant Option
                            <span className="text-danger">*</span>
                          </Label>
                          <select
                            value={editForm.variantOptionId}
                            name="variantOptionId"
                            required
                            onChange={handleEditChange}
                            className="form-select"
                            disabled={isLoading}
                          >
                            <option value="">Select Variant Option</option>
                            {variantOptions.map(item => (
                              <option key={item._id} value={item._id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </Col>
                      <Col md={4}>
                        <Label>
                          Price <span className="text-danger">*</span>
                        </Label>
                        <Input
                          required
                          name="price"
                          type="number"
                          min="0"
                          step="0.01"
                          value={editForm.price}
                          placeholder="Enter Price"
                          onChange={handleEditChange}
                          disabled={isLoading}
                        />
                      </Col>
                    </Row>
                    <div className="text-end mt-4">
                      <Button
                        type="button"
                        size="sm"
                        onClick={() => setShowEdit(false)}
                        color="danger m-1"
                        disabled={isLoading}
                      >
                        Cancel <i className="bx bx-x-circle"></i>
                      </Button>
                      <Button
                        type="submit"
                        size="sm"
                        color="primary text-white m-1"
                        disabled={isLoading}
                      >
                        {isLoading ? "Updating..." : "Update"}{" "}
                        <i className="bx bx-check-circle"></i>
                      </Button>
                    </div>
                  </Form>
                </Card>
              </Col>
            </Row>
          )}

          <Row>
            <Col md={12}>
              <Card>
                <CardBody>
                  <Row className="mb-3">
                    <Col>
                      <Button
                        onClick={() => navigate.goBack()}
                        style={{ float: "right" }}
                        color="primary"
                        size="sm"
                      >
                        <i className="far fa-arrow-alt-circle-left me-2"></i>
                        Back
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={6}>
                      <Button
                        color="primary"
                        onClick={toggleAddForm}
                        style={{ marginRight: "15px" }}
                        disabled={isLoading}
                        size="sm"
                      >
                        Create Manage Product Variant
                        <i className="bx bx-plus-circle"></i>
                      </Button>
                    </Col>
                    <Col md={6}>
                      <div className="float-end">
                        <Input
                          name="search"
                          onChange={handleSearch}
                          type="search"
                          placeholder="Search..."
                          disabled={isLoading}
                        />
                      </div>
                    </Col>
                  </Row>

                  {isLoading && !data.length ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <Table hover bordered>
                        <thead>
                          <tr className="text-center">
                            <th>SlNo</th>
                            <th>Product Name</th>
                            <th>Variant</th>
                            <th>Variant Option</th>
                            <th>Price</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems.length > 0 ? (
                            currentItems.map((item, index) => (
                              <tr key={item._id} className="text-center">
                                <td>{pagesVisited + index + 1}</td>
                                <td>{item.productName}</td>
                                <td>{item.variantName}</td>
                                <td>{item.varaintoptionName}</td>
                                <td>{item.price}</td>
                                <td>
                                  {/* <Button
                                    onClick={() => handleEdit(item)}
                                    size="sm"
                                    className="m-1"
                                    color="primary"
                                    disabled={isLoading}
                                    outline
                                  > */}
                                  <i
                                    className="bx bx-edit text-primary me-2 "
                                    style={{
                                      fontSize: "22px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => handleEdit(item)}
                                  ></i>
                                  {/* </Button> */}
                                  {/* <Button
                                    size="sm"
                                    className="m-1"
                                    color="danger"
                                    onClick={() => handleDelete(item)}
                                    disabled={isLoading}
                                    outline
                                  > */}
                                  <i
                                    className="bx bx-trash text-primary"
                                    style={{
                                      fontSize: "22px",
                                      cursor: "pointer",
                                    }}
                                     onClick={() => handleDelete(item)}
                                  ></i>
                                  {/* </Button> */}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center py-4">
                                No variants found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>

                      {pageCount > 1 && (
                        <div className="d-flex justify-content-end mt-3">
                          <ReactPaginate
                            previousLabel={"Previous"}
                            nextLabel={"Next"}
                            pageCount={pageCount}
                            onPageChange={changePage}
                            containerClassName={"pagination"}
                            previousLinkClassName={"page-link"}
                            nextLinkClassName={"page-link"}
                            disabledClassName={"disabled"}
                            activeClassName={"active"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                            disabled={isLoading}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    </React.Fragment>
  )
}

export default ProductsVariants
